import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className="foot">
            <h4>Stay with us</h4>
            
            <h6>Copyright © Tourism management system</h6>
            <h6>Contact With us</h6>
            <h6>☎ +9111100</h6>
            <h6>✉ : tourismmanagement@gmail.com</h6>
           
            
        </div>
    );
};

export default Footer;